module.exports = __webpack_public_path__ + "img/pics.601cf024.gif";